var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "igc-frame" }, [
    _c("div", { staticClass: "ig--header" }, [
      _c("div", {
        staticClass: "ig--close",
        style: {
          "background-image":
            "url(" +
            _vm.imagePath +
            "/" +
            (_vm.igEnv == "development" ? "test_" : "") +
            "close.png)"
        },
        on: { click: _vm.close }
      }),
      _c("div", { staticClass: "ig--placeholder" }),
      _vm.config.search.length > 0
        ? _c("div", {
            staticClass: "ig--search",
            style: {
              "background-image":
                "url(" +
                _vm.imagePath +
                "/" +
                (_vm.igEnv == "development" ? "test_" : "") +
                "search.png)"
            },
            on: { click: _vm.toSearch }
          })
        : _vm._e(),
      _vm.tokenParams && !_vm.config.options.me
        ? _c("div", { staticClass: "ig--avatar", on: { click: _vm.toMe } }, [
            _c("div", {
              staticClass: "ig--border",
              style: {
                "background-image": "url(" + _vm.imagePath + "/avatar.png)"
              }
            }),
            _vm.userInfo.avatar
              ? _c("div", {
                  staticClass: "ig--image",
                  style: {
                    "background-image": "url(" + _vm.userInfo.avatar + ")"
                  }
                })
              : _vm._e()
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "ig--container" }, [
      _c(
        "ul",
        { staticClass: "ig--navbar", class: ["ig--" + _vm.$route.name] },
        _vm._l(_vm.config.navigators, function(item, key) {
          return _vm.config.options[key]
            ? _c(
                "li",
                {
                  key: key,
                  staticClass: "ig--navigator",
                  style: { order: item.sort },
                  on: {
                    click: function($event) {
                      return _vm.toModule(item, key)
                    }
                  }
                },
                [
                  key == "me" && _vm.messageNum > 0
                    ? _c("div", { staticClass: "ig--redpoint" })
                    : _vm._e()
                ]
              )
            : _vm._e()
        }),
        0
      ),
      _c("div", { staticClass: "ig--wrapper" }, [_vm._t("default")], 2)
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }